import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Title } from 'components'
import { Table } from '@sar/component'

async function fetchData (id, params, store) {
  const result = await store.externals.api.get(`/paymentRecords/${id}`, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

export default function ({ store, params, navigator }) {
  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
    },
    {
      title: '订单号',
      dataIndex: 'orderNumber',
      fieldProps: { placeholder: '填写订单号查询' },
      formItemProps: { label: false },
    },
    {
      title: '查询时间',
      dataIndex: 'date',
      valueType: 'dateRange',
      hideInTable: true,
      fieldProps: { placeholder: [ '开始时间', '结束时间' ] },
      formItemProps: { label: false },
    },
    {
      title: '货款类型',
      dataIndex: 'item',
      valueType: 'select',
      valueEnum: { '订金': '订金', '尾款': '尾款' },
      fieldProps: { placeholder: '选择货款类型查询' },
      formItemProps: { label: false },
    },
    {
      title: '总金额',
      dataIndex: 'totalAmount',
    },
    {
      title: '已付款',
      dataIndex: 'amount',
    },
    {
      title: '结算方式',
      dataIndex: 'payStatus',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
    },
    {
      title: '收款人',
      dataIndex: 'createName',
    },
  ]

  const actions = [
    {
      name: '新增',
      type: 'normal',
      visible: () => store.identity.hasPermission('/collection/list/flow:create'),
      onClick: () => navigator.to(`/collection/list/flow/create/${params.id}`, `新增收款流水`),
    },
  ]

  const rowActions = [
    {
      name: '查看',
      visible: () => store.identity.hasPermission('/collection/list/flow:detail'),
      onClick: (data, handles) => navigator.to(`/collection/list/flow/detail/${params.id}/${data.id}`, `收款流水详情（${data.id}）`),
    },
    {
      danger: true,
      name: '删除',
      confirmType: 'modal',
      confirmMessage: '您确定删除这条流水记录吗？',
      visible: () => store.identity.hasPermission('/collection/list/flow:delete'),
      onConfirm: (data, handles) => store.externals.api.delete(`/paymentRecords/flow/${data.id}`).then(() => handles.current.reload()),
    },
  ]

  const cols = React.useMemo(() => {
    let showSearch = [
        'item'
      , 'date'
    ]

    return columns.map(column => {
      if (showSearch.includes(column.dataIndex)) {
        return Object.assign(column)
      }

      else {
        return Object.assign(column, { hideInSearch: true })
      }
    })
  }, [])

  return <div className='p-4'>
    <Table
      key={params.id}
      scroll={{ }}
      title='收款流水列表'
      columns={cols}
      actions={actions}
      rowActions={rowActions}
      request={data => fetchData(params.id, data, store)}
      search={{ labelWidth: 'auto', span: store.config.responsive }}
    />
  </div>
}
